console.log("pro-forma-payload ver. 260817a-raw-properties")
class FormHandler {
    constructor(config = {}) {
        // Merge default config with provided config
        this.config = {
            DISCOUNT_VALUE: 3800,
            MINIMUM_CART_VALUE: 0, // New parameter: minimum cart value (0 = no minimum)
            MINIMUM_ONLY_AFFECTS_DISCOUNT: false, // When true: below minimum removes discount but allows submission
            FORM_SELECTOR: "form.gp-form-g1t1y_2ZFS",
            API_ENDPOINT:
                "https://api.plumsail.com/api/v2/processes/tenqdzun/wrkpuds/start",
            THANK_YOU_PAGE: "/pages/thank-you",
            CURRENCY_LOCALE: "en-GB",
            LANGUAGE: "en",
            ...config,
        };

        // Translation management (user-facing text only)
        this.translations = {
            pl: {
                // Field labels
                email: "Email",
                phone: "Numer telefonu",
                firstName: "Imię",
                lastName: "Nazwisko",
                country: "Kraj / region",
                address: "Adres",
                postalCode: "Kod pocztowy",
                city: "Miasto",
                firstNameBilling: "Imię",
                lastNameBilling: "Nazwisko",
                countryBilling: "Kraj / region",
                addressBilling: "Adres",
                postalCodeBilling: "Kod pocztowy",
                cityBilling: "Miasto",

                // Error messages
                emailRequired: "Wprowadź adres email",
                emailInvalid: "Wprowadź poprawny adres email",
                emailTooLong: "Adres email jest za długi",
                fieldRequired: "Wprowadź {field}",
                minimumCartValue: "Minimalna wartość zamówienia to {minimum}. Aktualna wartość: {current}",
                discountRemoved: "Rabat został usunięty, ponieważ wartość zamówienia {current} jest poniżej minimum {minimum}",
                cartEmpty: "Koszyk jest pusty",

                // Button states
                pleaseWait: "Proszę czekać",

                // User-facing error
                submissionErrorMessage:
                    "Wystąpił błąd podczas przesyłania formularza. Spróbuj ponownie.",

                // API errors
                cartFetchFailed: "Nie udało się pobrać koszyka",
                apiRequestFailed: "Błąd zapytania do API",
            },
            de: {
                // Field labels
                email: "E-Mail",
                phone: "Telefonnummer",
                firstName: "Vorname",
                lastName: "Nachname",
                country: "Land / Region",
                address: "Adresse",
                postalCode: "Postleitzahl",
                city: "Stadt",
                firstNameBilling: "Vorname",
                lastNameBilling: "Nachname",
                countryBilling: "Land / Region",
                addressBilling: "Adresse",
                postalCodeBilling: "Postleitzahl",
                cityBilling: "Stadt",

                // Error messages
                emailRequired: "Bitte E-Mail eingeben",
                emailInvalid: "Bitte eine gültige E-Mail-Adresse eingeben",
                emailTooLong: "Die E-Mail-Adresse ist zu lang",
                fieldRequired: "Bitte {field} eingeben",
                minimumCartValue: "Mindestbestellwert ist {minimum}. Aktueller Wert: {current}",
                discountRemoved: "Rabatt wurde entfernt, da der Bestellwert {current} unter dem Minimum {minimum} liegt",
                cartEmpty: "Der Warenkorb ist leer",

                // Button states
                pleaseWait: "Bitte warten",

                // User-facing error
                submissionErrorMessage:
                    "Beim Absenden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",

                // API errors
                cartFetchFailed: "Warenkorb konnte nicht abgerufen werden",
                apiRequestFailed: "API-Anfrage fehlgeschlagen",
            },
            fr: {
                // Field labels
                email: "E-mail",
                phone: "Numéro de téléphone",
                firstName: "Prénom",
                lastName: "Nom",
                country: "Pays / Région",
                address: "Adresse",
                postalCode: "Code postal",
                city: "Ville",
                firstNameBilling: "Prénom",
                lastNameBilling: "Nom",
                countryBilling: "Pays / Région",
                addressBilling: "Adresse",
                postalCodeBilling: "Code postal",
                cityBilling: "Ville",

                // Error messages
                emailRequired: "Veuillez saisir un e-mail",
                emailInvalid: "Veuillez saisir une adresse e-mail valide",
                emailTooLong: "L'adresse e-mail est trop longue",
                fieldRequired: "Veuillez saisir {field}",
                minimumCartValue: "La valeur minimale de commande est {minimum}. Valeur actuelle: {current}",
                discountRemoved: "La remise a été supprimée car la valeur de la commande {current} est inférieure au minimum {minimum}",
                cartEmpty: "Le panier est vide",

                // Button states
                pleaseWait: "Veuillez patienter",

                // User-facing error
                submissionErrorMessage:
                    "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer.",

                // API errors
                cartFetchFailed: "Échec de la récupération du panier",
                apiRequestFailed: "La requête API a échoué",
            },
            cs: {
                // Field labels
                email: "E-Mail",
                phone: "Telefonní číslo",
                firstName: "Jméno",
                lastName: "Příjmení",
                country: "Země / Region",
                address: "Adresa",
                postalCode: "PSČ",
                city: "Město",
                firstNameBilling: "Jméno",
                lastNameBilling: "Příjmení",
                countryBilling: "Země/Region",
                addressBilling: "Adresa",
                postalCodeBilling: "PSČ",
                cityBilling: "Město",

                // Error messages
                emailRequired: "Zadejte prosím E-Mail",
                emailInvalid: "Zadejte prosím platnou e-mailovou adresu",
                emailTooLong: "E-mailová adresa je příliš dlouhá",
                fieldRequired: "Zadejte prosím {field}",
                minimumCartValue: "Minimální hodnota objednávky je {minimum}. Aktuální hodnota: {current}",
                discountRemoved: "Sleva byla odstraněna, protože hodnota objednávky {current} je pod minimem {minimum}",
                cartEmpty: "Košík je prázdný",

                // Button states
                pleaseWait: "Prosím čekejte",

                // User-facing error
                submissionErrorMessage:
                    "Došlo k chybě při odesílání formuláře. Zkuste to prosím znovu.",

                // API errors
                cartFetchFailed: "Nepodařilo se načíst košík",
                apiRequestFailed: "API požadavek se nezdařil",
            },
            lt: {
                // Field labels
                email: "El. paštas",
                phone: "Jūsų mobilųjį telefono numerį",
                firstName: "Vardą",
                lastName: "Pavardę",
                country: "Šalį / regioną",
                address: "Adresą",
                postalCode: "Pašto kodą",
                city: "Miestą",
                firstNameBilling: "Vardą",
                lastNameBilling: "Pavardę",
                countryBilling: "Šalį / regioną",
                addressBilling: "Adresą",
                postalCodeBilling: "Pašto kodą",
                cityBilling: "Miestą",

                // Error messages
                emailRequired: "Įveskite el. pašto adresą",
                emailInvalid: "Įveskite teisingą el. pašto adresą",
                emailTooLong: "El. pašto adresas per ilgas",
                fieldRequired: "Įveskite {field}",
                minimumCartValue: "Minimali užsakymo vertė yra {minimum}. Dabartinė vertė: {current}",
                discountRemoved: "Nuolaida nepritaikyta, nes užsakymo vertė {current} yra mažesnė nei minimali {minimum}",
                cartEmpty: "Krepšelis tuščias",

                // Button states
                pleaseWait: "Prašome palaukti",

                // User-facing error
                submissionErrorMessage:
                    "Pateikiant formą įvyko klaida. Bandykite dar kartą.",

                // API errors
                cartFetchFailed: "Nepavyko gauti krepšelio",
                apiRequestFailed: "API užklausa nepavyko",
            },

            en: {
                // Field labels
                email: "email",
                phone: "telephone",
                firstName: "first name",
                lastName: "last name",
                country: "country / region",
                address: "address",
                postalCode: "postcode",
                city: "city",
                firstNameBilling: "first name",
                lastNameBilling: "last name",
                countryBilling: "country / region",
                addressBilling: "address",
                postalCodeBilling: "postcode",
                cityBilling: "city",

                // Error messages
                emailRequired: "Please enter your email",
                emailInvalid: "Please enter a valid email",
                emailTooLong: "Email address is too long",
                fieldRequired: "Please enter your {field}",
                minimumCartValue: "Minimum order value is {minimum}. Current value: {current}",
                discountRemoved: "Discount removed because order value {current} is below minimum {minimum}",
                cartEmpty: "Cart is empty",

                // Button states
                pleaseWait: "Please wait",

                // User-facing error
                submissionErrorMessage:
                    "An error occurred while submitting the form. Please try again.",

                // API errors
                cartFetchFailed: "Failed to fetch cart",
                apiRequestFailed: "API request failed",
            },
        };

        this.form = null;
        this.submitButton = null;
        this.fields = {};
        this.currentCartValue = null; // Store current cart value for validation
    }

    /**
     * Get translated text
     * @param {string} key - Translation key
     * @param {Object} params - Parameters for string interpolation
     * @returns {string} - Translated text
     */
    t(key, params = {}) {
        const currentLang = this.config.LANGUAGE;

        let text = this.translations[currentLang]?.[key] || key;

        // Simple string interpolation
        if (params && typeof text === "string") {
            Object.keys(params).forEach((param) => {
                text = text.replace(`{${param}}`, params[param]);
            });
        }

        return text;
    }

    /**
     * Set the current language
     * @param {string} language - Language code (e.g., 'cs', 'en')
     */
    setLanguage(language) {
        if (this.translations[language]) {
            this.config.LANGUAGE = language;
            console.log(`🌐 Language set to: ${language}`);
        } else {
            console.warn(
                `⚠️ Language '${language}' not supported. Available languages: ${Object.keys(
                    this.translations
                ).join(", ")}`
            );
        }
    }

    /**
     * Add or update translations for a specific language
     * @param {string} language - Language code
     * @param {Object} translations - Translation object
     */
    addTranslations(language, translations) {
        if (!this.translations[language]) {
            this.translations[language] = {};
        }

        this.translations[language] = {
            ...this.translations[language],
            ...translations,
        };

        console.log(`🌐 Translations added for language: ${language}`);
    }

    /**
     * Get available languages
     * @returns {Array} - Array of available language codes
     */
    getAvailableLanguages() {
        return Object.keys(this.translations);
    }

    init() {
        this.form = document.querySelector(this.config.FORM_SELECTOR);
        this.submitButton = this.form?.querySelector('button[type="submit"]');

        if (!this.form || !this.submitButton) {
            console.warn("❌ Form or submit button not found");
            return false;
        }

        this.setupFields();
        this.setupEventListeners();
        this.setupBillingToggle();

        return true;
    }

    setupFields() {
        this.fields = {
            email: {
                input: this.form.querySelector('input[name="contact[email]"]'),
                label: this.t("email"),
            },
            phone: {
                input: this.form.querySelector('input[name="contact[phone]"]'),
                label: this.t("phone"),
            },
            firstName: {
                input: this.form.querySelector('input[name="contact[firstName]"]'),
                label: this.t("firstName"),
            },
            lastName: {
                input: this.form.querySelector('input[name="contact[lastName]"]'),
                label: this.t("lastName"),
            },
            country: {
                input: this.form.querySelector('select[name="contact[countryCode]"]'),
                label: this.t("country"),
            },
            address: {
                input: this.form.querySelector('input[name="contact[address1]"]'),
                label: this.t("address"),
            },
            postalCode: {
                input: this.form.querySelector('input[name="contact[postalCode]"]'),
                label: this.t("postalCode"),
            },
            city: {
                input: this.form.querySelector('input[name="contact[city]"]'),
                label: this.t("city"),
            },
            // billing fields
            firstNameBilling: {
                input: this.form.querySelector(
                    'input[name="contact[firstNameBilling]"]'
                ),
                label: this.t("firstNameBilling"),
            },
            lastNameBilling: {
                input: this.form.querySelector(
                    'input[name="contact[lastNameBilling]"]'
                ),
                label: this.t("lastNameBilling"),
            },
            countryBilling: {
                input: this.form.querySelector(
                    'select[name="contact[countryCodeBilling]"]'
                ),
                label: this.t("countryBilling"),
            },
            addressBilling: {
                input: this.form.querySelector(
                    'input[name="contact[address1Billing]"]'
                ),
                label: this.t("addressBilling"),
            },
            postalCodeBilling: {
                input: this.form.querySelector(
                    'input[name="contact[postalCodeBilling]"]'
                ),
                label: this.t("postalCodeBilling"),
            },
            cityBilling: {
                input: this.form.querySelector('input[name="contact[cityBilling]"]'),
                label: this.t("cityBilling"),
            },
        };
    }

    setupEventListeners() {
        // Set up input event listeners
        Object.values(this.fields).forEach(({ input }) => {
            if (!input) return;
            input.addEventListener("input", () => {
                if (input.value.trim()) {
                    this.clearError(input);
                }
            });
        });

        // Set up submit handler
        this.submitButton.addEventListener("click", (e) => this.handleSubmit(e));
    }

    setupBillingToggle() {
        const options = document.querySelectorAll(".billing-toggle .radio-option");
        const gemForm = document.querySelector(".gem-billing-address-form");

        if (gemForm) {
            gemForm.style.display = "none";
        }

        options.forEach((option) => {
            option.addEventListener("click", () => {
                options.forEach((o) => o.classList.remove("selected"));
                option.classList.add("selected");

                const radio = option.querySelector('input[type="radio"]');
                if (radio) {
                    radio.checked = true;
                    const show = radio.value === "different";
                    if (gemForm) {
                        gemForm.style.display = show ? "block" : "none";
                    }
                    console.log(show ? "address different" : "address same");
                }
            });
        });
    }

    // Utility methods

    createError(input, message) {
        if (!input) return;

        let error = input.parentElement.querySelector(".gempages-error");
        if (!error) {
            error = document.createElement("div");
            error.className = "gempages-error";
            error.style.cssText = "color: #f44336; font-size: 12px; margin-top: 4px;";
            input.parentElement.appendChild(error);
        }
        error.textContent = message;
    }

    clearError(input) {
        if (!input) return;
        const error = input.parentElement.querySelector(".gempages-error");
        if (error) error.remove();
    }

    isBillingAddressDifferent() {
        const billingRadio = document.querySelector(
            'input[type="radio"][value="different"]:checked'
        );
        return billingRadio !== null;
    }

    resetButtonState(originalText) {
        this.submitButton.innerHTML = originalText;
        this.submitButton.disabled = false;
    }

    setLoadingState() {
        const originalText = this.submitButton.innerHTML;
        this.submitButton.innerHTML = `
      <span class="spinner"></span>
      ${this.t("pleaseWait")}
    `;
        this.submitButton.disabled = true;
        return originalText;
    }

    /**
     * Format currency value for display
     * @param {number} value - The value to format
     * @param {string} currency - The currency code
     * @returns {string} - Formatted currency string
     */
    formatCurrency(value, currency) {
        return value.toLocaleString(this.config.CURRENCY_LOCALE, {
            style: "currency",
            currency: currency,
        });
    }

    validateForm() {
        let isValid = true;
        const isDifferentBilling = this.isBillingAddressDifferent();

        // Validate individual fields with specific rules
        const validations = [
            // Email validation
            () => {
                const emailInput = this.fields.email.input;
                if (!emailInput) return true;

                const email = emailInput.value.trim();
                const emailRegex =
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

                if (!email) {
                    this.createError(emailInput, this.t("emailRequired"));
                    return false;
                } else if (!emailRegex.test(email)) {
                    this.createError(emailInput, this.t("emailInvalid"));
                    return false;
                } else if (email.length > 254) {
                    this.createError(emailInput, this.t("emailTooLong"));
                    return false;
                } else {
                    this.clearError(emailInput);
                    return true;
                }
            },

            // Core fields validation
            () => {
                const coreFields = [
                    "phone",
                    "firstName",
                    "lastName",
                    "country",
                    "address",
                    "postalCode",
                    "city",
                ];
                let fieldsValid = true;

                coreFields.forEach((key) => {
                    const { input, label } = this.fields[key];
                    if (!input) return;

                    const value = input.value.trim();
                    if (!value) {
                        fieldsValid = false;
                        this.createError(input, this.t("fieldRequired", { field: label }));
                    } else {
                        this.clearError(input);
                    }
                });

                return fieldsValid;
            },

            // Billing fields validation
            () => {
                if (!isDifferentBilling) return true;

                const billingFields = [
                    "firstNameBilling",
                    "lastNameBilling",
                    "countryBilling",
                    "addressBilling",
                    "postalCodeBilling",
                    "cityBilling",
                ];
                let billingValid = true;

                billingFields.forEach((key) => {
                    const { input, label } = this.fields[key];
                    if (!input) return;

                    const value = input.value.trim();
                    if (!value) {
                        billingValid = false;
                        this.createError(input, this.t("fieldRequired", { field: label }));
                    } else {
                        this.clearError(input);
                    }
                });

                return billingValid;
            },
        ];

        // Run all validations
        validations.forEach((validate) => {
            if (!validate()) {
                isValid = false;
            }
        });

        return isValid;
    }

    extractFormData() {
        const isDifferentBilling = this.isBillingAddressDifferent();

        const email = this.fields.email.input?.value.trim() || "";
        const phone = this.fields.phone.input?.value.trim() || "";
        const firstName = this.fields.firstName.input?.value.trim() || "";
        const lastName = this.fields.lastName.input?.value.trim() || "";
        const country = this.fields.country.input?.value.trim() || "";
        const address = this.fields.address.input?.value.trim() || "";
        const postalCode = this.fields.postalCode.input?.value.trim() || "";
        const city = this.fields.city.input?.value.trim() || "";

        let firstNameBilling,
            lastNameBilling,
            countryBilling,
            addressBilling,
            postalCodeBilling,
            cityBilling;

        if (isDifferentBilling) {
            firstNameBilling =
                this.fields.firstNameBilling.input?.value.trim() || firstName;
            lastNameBilling =
                this.fields.lastNameBilling.input?.value.trim() || lastName;
            countryBilling =
                this.fields.countryBilling.input?.value.trim() || country;
            addressBilling =
                this.fields.addressBilling.input?.value.trim() || address;
            postalCodeBilling =
                this.fields.postalCodeBilling.input?.value.trim() || postalCode;
            cityBilling = this.fields.cityBilling.input?.value.trim() || city;
        } else {
            firstNameBilling = firstName;
            lastNameBilling = lastName;
            countryBilling = country;
            addressBilling = address;
            postalCodeBilling = postalCode;
            cityBilling = city;
        }

        return {
            email,
            phone,
            firstName,
            lastName,
            country,
            address,
            postalCode,
            city,
            firstNameBilling,
            lastNameBilling,
            countryBilling,
            addressBilling,
            postalCodeBilling,
            cityBilling,
        };
    }

    async processCart(formData) {
        try {
            // Reset any completed-order snapshot from a prior submit attempt so a blocked
            // submission (e.g. below minimum) can never fire stale completion analytics.
            this.completedOrder = null;

            const response = await fetch("/cart.js");
            if (!response.ok) throw new Error(this.t("cartFetchFailed"));

            const cart = await response.json();

            console.log("🔎 PROFORMA cart token:", cart.token);
            console.log("🔎 PROFORMA item properties:", cart.items?.map((item) => item.properties));

            if (!cart.items || cart.items.length === 0) {
                console.warn("🟠 Cart is empty — skipping invoice");
                alert(this.t("cartEmpty"));
                return null;
            }

            // Store cart value for validation
            this.currentCartValue = cart.total_price;

            // Check if cart meets minimum value
            const actualValue = cart.total_price / 100; // Convert from cents to main currency unit
            let effectiveDiscount = this.config.DISCOUNT_VALUE;

            if (this.config.MINIMUM_CART_VALUE > 0 && actualValue < this.config.MINIMUM_CART_VALUE) {
                const minimumFormatted = this.formatCurrency(this.config.MINIMUM_CART_VALUE, cart.currency);
                const currentFormatted = this.formatCurrency(actualValue, cart.currency);

                // Log the config values for debugging
                console.log(`📊 Minimum check: Cart value: ${currentFormatted}, Minimum: ${minimumFormatted}`);
                console.log(`📊 MINIMUM_ONLY_AFFECTS_DISCOUNT: ${this.config.MINIMUM_ONLY_AFFECTS_DISCOUNT}`);

                if (this.config.MINIMUM_ONLY_AFFECTS_DISCOUNT === true) {
                    // Only remove discount, don't block submission
                    effectiveDiscount = 0;
                    console.warn(`⚠️ Discount removed: cart value ${currentFormatted} is below minimum ${minimumFormatted}`);
                    alert(this.t("discountRemoved", {
                        minimum: minimumFormatted,
                        current: currentFormatted
                    }));
                } else {
                    // Block submission entirely
                    alert(this.t("minimumCartValue", {
                        minimum: minimumFormatted,
                        current: currentFormatted
                    }));
                    console.warn(`❌ Cart value ${currentFormatted} is below minimum ${minimumFormatted}`);
                    return null; // Return null to stop processing
                }
            } else {
                console.log(`✅ Cart value meets minimum or no minimum set`);
            }

            const unescapeHtml = (text) =>
                String(text)
                    .replace(/&amp;/g, "&")
                    .replace(/&lt;/g, "<")
                    .replace(/&gt;/g, ">")
                    .replace(/&quot;/g, '"')
                    .replace(/&#039;/g, "'");

            const appendWidthParam = (url, width) => {
                if (!url) return null;
                return url.includes("?v=") ? `${url}&width=${width}` : url;
            };

            const formattedItems = cart.items.map((item) => {
                const props = Object.entries(item.properties || {})
                    .filter(([k, v]) => v && !k.startsWith("_"))
                    .reduce((acc, [k, v]) => {
                        acc[k] = v;
                        return acc;
                    }, {});

                const entries = Object.entries(props);
                const propertiesText = entries.length
                    ? "\n" + entries.map(([k, v]) => `${unescapeHtml(k)}: ${unescapeHtml(v)}`).join("\n")
                    : "";

                // Use discounted values; compute fallback when Shopify omits final_* fields
                const lineLevelDiscount = item.line_level_total_discount || item.total_discount || 0;
                const finalLineCents =
                    item.final_line_price != null
                        ? item.final_line_price
                        : item.line_price - lineLevelDiscount;
                const finalUnitCents =
                    item.final_price != null
                        ? item.final_price
                        : finalLineCents / Math.max(item.quantity || 1, 1);
                const finalUnitValue = finalUnitCents / 100;
                const finalLineValue = finalLineCents / 100;

                const preview = item.properties?._preview;
                const leadTime = item.properties?._lead_time;
                const leadTimeText = leadTime ? leadTime.toUpperCase() : null;
                const isHotTub = item.product_type === "Hot Tub";
                const isConfig = item.product_type === "Config" || item.product_type === "Sauna";
                const proformaImage = isConfig && item.properties?._preview
                    ? item.properties._preview
                    : isHotTub && item.properties?._second_image
                        ? appendWidthParam(item.properties._second_image, 350)
                        : isHotTub && item.featured_image?.url
                            ? appendWidthParam(item.featured_image.url, 350)
                            : null;
                return {
                    name: unescapeHtml(item.title),
                    title: unescapeHtml(item.title), // 👈 fix: decode before sending
                    sku: item.sku || "DEFAULT",
                    externalId: item.sku || "DEFAULT",
                    quantity: item.quantity,
                    price: finalUnitValue,
                    unitPrice: this.formatCurrency(finalUnitValue, cart.currency),
                    totalPrice: this.formatCurrency(finalLineValue, cart.currency),
                    ...(propertiesText && { properties: propertiesText }),
                    ...(preview && { _preview: preview }),
                    ...(leadTimeText && { _lead_time: leadTimeText }),
                    ...(proformaImage && { _proforma_image: proformaImage }),
                    // Full structured data for downstream consumers (Make ->
                    // kubilokelias). Plumsail templates ignore unknown fields,
                    // so the PDF/email are unaffected. rawProperties keeps ALL
                    // cart properties verbatim, including the _-prefixed ones
                    // (_cl_options etc.) that the display-only `properties`
                    // text above deliberately strips.
                    rawProperties: item.properties || {},
                    productId: item.product_id,
                    variantId: item.variant_id,
                    productType: item.product_type || "",
                };
            });

            const formattedItemImages = cart.items
                .map(({ product_type, featured_image, properties }) => {
                    const isHotTub = product_type === "Hot Tub";
                    const isConfig = product_type === "Config" || product_type === "Sauna";
                    const url =
                        isConfig && properties?._preview
                            ? properties._preview
                            : isHotTub && featured_image?.url
                                ? appendWidthParam(featured_image.url, 350)
                                : null;
                    const url2 =
                        isHotTub && properties?._second_image
                            ? appendWidthParam(properties._second_image, 350)
                            : null;
                    return url || url2 ? { ...(url && { url_1: url }), ...(url2 && { url_2: url2 }) } : null;
                })
                .filter(Boolean);

            const formattedItemLeadTime = cart.items
                .map(({ product_type, properties }) => {
                    const isHotTub = product_type === "Hot Tub";
                    const isConfig = product_type === "Config" || product_type === "Sauna";
                    if (!isHotTub && !isConfig) {
                        return null;
                    }
                    const leadTime = properties?._lead_time
                        ? String(properties._lead_time).trim().toUpperCase()
                        : null;
                    return { string: leadTime || "◇" };
                })
                .filter(Boolean);

            const debugInfo = cart.items
                .map((item, index) => {
                    const props = item.properties || {};
                    const propKeys = Object.keys(props);
                    const leadTimeRaw = props._lead_time;
                    const leadTimeOk = Boolean(leadTimeRaw && String(leadTimeRaw).trim());
                    const hasSecondImage = Boolean(props._second_image);
                    const issues = [];
                    if (!leadTimeOk) {
                        issues.push("missing _lead_time");
                    }
                    if (!hasSecondImage) {
                        issues.push("missing _second_image");
                    }
                    const sku = item.sku?.toUpperCase() || "DEFAULT";
                    const type = item.product_type || "unknown";
                    return `${index}:${sku} type=${type} props=${propKeys.join(",") || "none"} lead_time=${JSON.stringify(leadTimeRaw ?? "")} _lead_time=${leadTimeOk ? "ok" : "missing"} _second_image=${hasSecondImage ? "ok" : "missing"}${issues.length ? " issues=" + issues.join(", ") : ""}`;
                })
                .join(" | ");

            const subtotal = this.formatCurrency(
                cart.items_subtotal_price / 100,
                cart.currency
            );

            const discountFormatted =
                effectiveDiscount > 0
                    ? this.formatCurrency(-Math.abs(effectiveDiscount), cart.currency)
                    : this.formatCurrency(0, cart.currency);

            const grandTotalValue =
                cart.total_price / 100 - effectiveDiscount;

            const grandTotal = this.formatCurrency(grandTotalValue, cart.currency);

            // Stash the order snapshot (cart + invoiced total) for completion analytics,
            // emitted from handleSubmit via window.ProformaTracking. Captured here so tracked
            // revenue matches the billed grand total and the exact cart used for the invoice.
            this.completedOrder = { cart, grandTotalValue };

            const halfTotalValue = (cart.total_price / 100) * 0.5;

            const halfTotal = this.formatCurrency(halfTotalValue, cart.currency);

            // Format current date for the invoice
            const now = new Date();
            const formattedDate = now.toLocaleDateString();

            return {
                FirstName: formData.firstName,
                LastName: formData.lastName,
                BillToName: `${formData.firstNameBilling} ${formData.lastNameBilling}`,
                BillToAddress: formData.addressBilling,
                BillToCodeCity: `${formData.postalCodeBilling} ${formData.cityBilling}`,
                BillToCountry: formData.countryBilling,
                ShipToName: `${formData.firstName} ${formData.lastName}`,
                ShipToAddress: formData.address,
                ShipToCodeCity: `${formData.postalCode} ${formData.city}`,
                ShipToPostcode: formData.postalCode,
                ShipToCity: formData.city,
                ShipToCountry: formData.country,
                date: formattedDate,
                item: formattedItems,
                itemImage: formattedItems,
                itemImages: formattedItemImages,
                itemLeadTime: formattedItemLeadTime,
                allItemsLeadTime: formattedItems
                    .map((item) => item._lead_time?.trim())
                    .filter(Boolean)
                    .join("\n"),
                debugInfo,
                discount: discountFormatted,
                email: formData.email,
                phone: formData.phone,
                subtotal,
                halfTotal,
                grandTotal,
                currency: cart.currency,
            };
        } catch (error) {
            console.error("❌ Cart processing error:", error);
            throw error;
        }
    }

    async sendInvoice(payload) {
        try {
            const json = JSON.stringify(payload);

            // ✅ Use fetch for cross-origin reliability
            const response = await fetch(this.config.API_ENDPOINT, {
                method: "POST",
                headers: { "Content-Type": "application/json;charset=utf-8" },
                body: json,
                keepalive: true, // allows send to complete during redirect/unload
            });

            if (!response.ok) {
                const text = await response.text().catch(() => "");
                console.error("❌ Plumsail responded with:", response.status, text);
                throw new Error(`${this.t("apiRequestFailed")}: ${response.status}`);
            }

            console.log("📤 Invoice sent successfully via fetch");
            return true;

        } catch (error) {
            console.error("❌ Invoice sending failed:", error);
            return false;
        }
    }

    async sendCheckoutProxy(formData) {
        const payload = {
            email: formData.email,
            tagsToRemove: ["proforma-abandoned"],
        };

        try {
            console.log("📬 Sending checkout proxy request");
            const response = await fetch("/apps/proforma-checkout", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error(`Proxy request failed: ${response.status}`);
            }

            console.log("📬 Checkout proxy request sent");
        } catch (error) {
            console.warn("⚠️ Checkout proxy request failed", error);
        }
    }

    async clearCart() {
        try {
            await fetch("/cart/clear.js", { method: "POST" });
            console.log("🧹 Cart cleared");
        } catch (error) {
            console.warn("⚠️ Failed to clear cart", error);
        }
    }

    /*
    async handleSubmit(e) {
        e.preventDefault();

        if (!this.validateForm()) {
            console.warn("❌ Validation failed");
            return;
        }

        const originalText = this.setLoadingState();

        try {
            const formData = this.extractFormData();
            const payload = await this.processCart(formData);

            if (!payload) {
                this.resetButtonState(originalText);
                return;
            }

            // Fire-and-forget background process
            this.sendInvoice(payload)
                .then(() => this.clearCart())
                .catch(error => {
                    console.warn("⚠️ Background send/clear failed:", error);
                });

            // Wait a short UX delay before redirect
            setTimeout(() => {
                window.location.href = this.config.THANK_YOU_PAGE;
            }, 3000);

        } catch (error) {
            console.error("❌ Form submission error:", error);
            this.resetButtonState(originalText);
            alert(this.t("submissionErrorMessage"));
        }
    }
    */
    async handleSubmit(e) {
        e.preventDefault();

        if (!this.validateForm()) {
            console.warn("❌ Validation failed");
            return;
        }

        const originalText = this.setLoadingState();

        try {
            const formData = this.extractFormData();
            const payload = await this.processCart(formData);

            if (!payload) {
                this.resetButtonState(originalText);
                return;
            }

            // === 0️) Send checkout proxy request ===
            this.sendCheckoutProxy(formData);

            // === 1️) Fire completed-order analytics (see assets/proforma-tracking.js) ===
            // Reuses the cart snapshot captured in processCart() — no extra /cart.js fetch.
            if (window.ProformaTracking?.trackCompleted) {
                window.ProformaTracking.trackCompleted({ ...this.completedOrder, formData });
            } else {
                console.warn("⚠️ ProformaTracking unavailable — completed-order analytics skipped");
            }

            // === 2️) Send invoice + clear cart (fire & forget) ===
            this.sendInvoice(payload)
                .then(() => this.clearCart())
                .catch(error => {
                    console.warn("⚠️ Background send/clear failed:", error);
                });

            // === 3️) Redirect after short UX delay ===
            setTimeout(() => {
                window.location.href = this.config.THANK_YOU_PAGE;
            }, 3000);

        } catch (error) {
            console.error("❌ Form submission error:", error);
            this.resetButtonState(originalText);
            alert(this.t("submissionErrorMessage"));
        }
    }

}

/*
// Usage examples:
document.addEventListener("DOMContentLoaded", function () {

  // Initialize with default configuration (no minimum cart value)
  const formHandler = new FormHandler();
  formHandler.init();

  // Example 1: Block orders below minimum value
  const formHandler = new FormHandler({
    DISCOUNT_VALUE: 5000,
    MINIMUM_CART_VALUE: 10000, // Minimum order: 10,000
    MINIMUM_ONLY_AFFECTS_DISCOUNT: false, // Block submission if below minimum
    FORM_SELECTOR: "form.custom-form-class",
    API_ENDPOINT: "https://your-api-endpoint.com/process",
    THANK_YOU_PAGE: "/custom-thank-you",
    CURRENCY_LOCALE: "en-US",
    LANGUAGE: "en"
  });
  formHandler.init();

  // Example 2: Remove discount for orders below minimum (but still allow submission)
  const formHandler = new FormHandler({
    DISCOUNT_VALUE: 5000,
    MINIMUM_CART_VALUE: 10000, // Minimum for discount: 10,000
    MINIMUM_ONLY_AFFECTS_DISCOUNT: true, // Only remove discount, don't block order
    LANGUAGE: "en"
  });
  formHandler.init();


  // Add custom translations
  formHandler.addTranslations('sk', {
    email: "E-mail",
    phone: "Telefónne číslo",
    firstName: "Meno",
    lastName: "Priezvisko",
    minimumCartValue: "Minimálna hodnota objednávky je {minimum}. Aktuálna hodnota: {current}",
    discountRemoved: "Zľava bola odstránená, pretože hodnota objednávky {current} je pod minimom {minimum}",
    cartEmpty: "Košík je prázdny",
  });

  // Switch language dynamically
  formHandler.setLanguage('sk');

  // Get available languages
  console.log('Available languages:', formHandler.getAvailableLanguages());

});
*/
